import { Dot } from 'recharts';
import { handleMouseEnter, handleMouseLeave } from '../../helpers/tooltip-functions';
import type { DotPayloadProps } from '../Charts/line-chart.component';

export const ActiveDot = ({ cy, cx, fill, item, onClick }: DotPayloadProps) => {
  return (
    <Dot
      r={4}
      cy={cy}
      cx={cx}
      fill={fill}
      stroke={'#fff'}
      strokeWidth={2}
      onMouseEnter={() => handleMouseEnter(item as string)}
      onMouseLeave={handleMouseLeave}
      onClick={onClick}
    />
  );
};
